import React from "react";
import { css } from "emotion";
import { defaultStyle } from "./styles";
import { intFormat } from "../utils/formats";

export const ItemCardInfoAverageMilesPerTicket = ({minMilesAdvanced}) => {
	return (
		<div
			className={css`
				${defaultStyle}
			`}
		>
			<p className="title">O que é média de milhas?</p>
			<p>
				É a quantidade média de milhas que poderemos utilizar nas emissões feitas através da sua
				conta para cada passageiro.
				<br />
				<br />
				Sempre que você cadastra ou edita uma oferta com quantidade de milhas maior do que { intFormat(minMilesAdvanced) },
				pode indicar a média de milhas por passageiro.
				<br />
				<br />
				Vale lembrar que a MaxMilhas pode emitir passagens com quantidade de milhas menor ou maior
				do que a média informada. No fim das vendas, a média de milhas por passageiro será igual ou
				superior à da sua oferta.
			</p>
		</div>
	);
};
